import { Alert, Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { CrateOrgApi, Org, UpdateOrgApi } from "../Api";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  p: 4,
};

interface Props {
  setOpenOrgModal: React.Dispatch<React.SetStateAction<boolean>>;
  updateData?: Org;
  fetchData(): Promise<void>;
}

export default function AddOrg({
  setOpenOrgModal,
  updateData,
  fetchData,
}: Props) {
  const [addOrg, setAddOrg] = useState<Org>({
    id: updateData ? updateData.id : "",
    description: updateData ? updateData.description : "",
    name: updateData ? updateData.name : "",
    location: updateData ? updateData.location : "",
    owner_id: "adminid",
  });
  const submitCrateOrg = async () => {
    try {
      if (addOrg.name !== "" || addOrg.location !== "") {
        const res = await CrateOrgApi(addOrg);
        await fetchData();
        setOpenOrgModal(false);
        if (res.code !== "ok") {
          return <Alert severity="error">Error on Create Organization</Alert>;
        }
      } else {
        return <Alert severity="error">Please fill all details</Alert>;
      }
    } catch (error) {
      console.log("Error:", error);
    }
    // await CrateOrgApi(addOrg)
  };

  const submitUpdateOrg = async () => {
    try {
      if (addOrg.name !== "" || addOrg.location !== "") {
        const res = await UpdateOrgApi(addOrg);
        await fetchData();
        if (res.code !== "ok") {
          return <Alert severity="error">Error on update Organization</Alert>;
        } else {
          return <Alert severity="success">Organization Updated</Alert>;
        }
      } else {
        return <Alert severity="error">Please fill all details</Alert>;
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setOpenOrgModal(false);
    }
    // await CrateOrgApi(addOrg)
  };

  return (
    <Box component="form" sx={style} noValidate autoComplete="off">
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        <Typography
          id="modal-modal-title"
          variant="h5"
          component="h2"
          marginBottom={"40px"}
          width={"100%"}
          // marginLeft={"250px"}
          style={{ textAlign: "center" }}
        >
          {updateData ? "Update Organization" : "Create A New Organization"}
        </Typography>
        <TextField
          // disabled={updateData ? true : false}
          id="org_name"
          label="Organization Name"
          defaultValue={addOrg.name}
          // style={{ marginLeft: "50px" }}
          sx={{ flex: "50%" }}
          onChange={(v) => setAddOrg({ ...addOrg, name: v.target.value })}
        />
        <TextField
          id="firmwareVersion"
          label="Description"
          defaultValue={addOrg.description}
          // style={{ marginLeft: "150px" }}
          sx={{ flex: "50%" }}
          onChange={(v) =>
            setAddOrg({
              ...addOrg,
              description: v.target.value,
            })
          }
        />
        <TextField
          id="firmwareVersion"
          label="Location"
          defaultValue={addOrg.location}
          // style={{ marginLeft: "150px" }}
          sx={{ flex: "50%" }}
          onChange={(v) =>
            setAddOrg({
              ...addOrg,
              location: v.target.value,
            })
          }
        />
        <Grid container justifyContent={"end"}>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginTop: "50px" }}
            onClick={() => setOpenOrgModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="success"
            variant="contained"
            style={{ marginLeft: "20px", marginTop: "50px" }}
            onClick={() => (updateData ? submitUpdateOrg() : submitCrateOrg())}
          >
            {updateData ? "Update" : "Add"}
          </Button>
        </Grid>
      </Box>
    </Box>
  );
}
